/**
 * SecondaryButton Component
 * Encapsulated secondary/outlined button with consistent styling
 */

import React from 'react';
import { Button, ButtonProps as MuiButtonProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export interface SecondaryButtonProps extends MuiButtonProps {
  // Inherits all MuiButton props
}

export const SecondaryButton: React.FC<SecondaryButtonProps> = ({ 
  sx,
  variant = 'outlined',
  ...props 
}) => {
  const theme = useTheme();
  
  const defaultStyles = {
    textTransform: 'none' as const,
    fontWeight: 600,
    padding: theme.spacing(1, 3),
    borderColor: theme.customColors.tableBorder,
    color: theme.palette.text.primary,
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.customColors.tableRowHover,
    },
    '&.Mui-disabled': {
      borderColor: theme.customColors.tableBorder,
      color: theme.palette.action.disabled,
    },
  };

  return (
    <Button
      variant={variant}
      sx={{
        ...defaultStyles,
        ...sx,
      }}
      {...props}
    />
  );
};

